<div container>
  <div class="cta-bottom card card--purple decorator--top d-flex flex-column flex-lg-row align-items-center">
    <div class="cta-bottom__img">
      <img class="img-fluid" [src]="'/assets/img/cta-bottom/'+data.icon+'.svg'" [alt]="data.alt || ''" />
    </div>
    <div class="cta-bottom__text flex-shrink-1 mb-4 mb-lg-0">
      <h3 class="title text-center text-lg-start mb-0" [innerHTML]="data.title"></h3>
      <p *ngIf="data.text" [innerHTML]="data.text"></p>
    </div>
    <div global-button class="cta-bottom__btn" [buttonData]="data.button"></div>
</div> 